module.exports = "/_next/static/images/sprite-a94d7945c618ad45f0918f11beedc4ba.svg";